import clsx from "clsx";
import { FaCheck } from "react-icons/fa";
import { BiChevronDown } from "react-icons/bi";
import { useMapFiltersStore } from "../../stores/filterMapStore";
import { MouseEvent, KeyboardEvent, useEffect, useRef, useState } from "react";

interface DropdownProps {
  options: { label: string; value?: string }[];
  label: string;
  positionY: "top" | "bottom";
}

const DropdownMultiple = ({ options, label, positionY }: DropdownProps) => {
  // const { selectedOptionMultiple, setSelectedOptionMultiple } =
  // 	useMapFiltersStore();
  const { propertyType, setPropertyType } = useMapFiltersStore();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (
    option: string,
    e: MouseEvent<HTMLDivElement> | KeyboardEvent<HTMLDivElement>
  ) => {
    e.stopPropagation();
    const allType = "All types";
    setPropertyType((prevType: string[]) => {
      if (option === allType) {
        return [allType];
      }
      const updatedTypes = prevType.includes(option)
        ? prevType.filter((type) => type !== option)
        : [...prevType.filter((item) => item !== allType), option];
      return updatedTypes.length === 0 ? [allType] : updatedTypes;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside as unknown as EventListener
    );
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside as unknown as EventListener
      );
    };
  }, [isOpen]);

  const displayLabel = () => {
    if (propertyType.length > 1) {
      // return selectedOptionList[0];
      return `${propertyType[0]} + ${propertyType.length - 1}`;
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (propertyType.length > 0) {
      return propertyType[0];
    }
    return label;
  };

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div
      ref={dropdownRef}
      className="relative h-full w-full px-5 flex items-center justify-center"
      onClick={toggleDropdown}
    >
      <button
        type="button"
        className="focus:outline-none flex items-center font-bold justify-between"
      >
        {displayLabel()}
        <span>
          <BiChevronDown
            className={clsx("text-xl transition-all", isOpen && "rotate-180")}
          />
        </span>
      </button>

      {isOpen && (
        <div
          className={clsx(
            "absolute z-10 mt-2 w-[250px] left-0 divide-y divide-gray-200 overflow-hidden bg-white border rounded-lg shadow-[0_4px_6px_-1px_rgba(0,0,0,0.10),0_2px_4px_-2px_rgba(0,0,0,0.05)]",
            positionY === "top" ? "top-14" : "bottom-7"
          )}
        >
          {options.map((option) => (
            <div
              key={option.label}
              onClick={(e) =>
                handleOptionClick(option.value ?? option.label, e)
              }
              onKeyDown={(e) =>
                handleOptionClick(option.value ?? option.label, e)
              }
              className={clsx(
                "px-4 py-2 w-full cursor-pointer flex items-center text-[#374151] text-sm font-normal",
                propertyType.includes(option.value ?? option.label) &&
                  "bg-z-dark-moss-green !text-white"
              )}
            >
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={propertyType.includes(option.value ?? option.label)}
                  className="hidden peer"
                />
                <span className="mr-2 w-5 h-5 bg-white border-2 border-gray-300 rounded-md flex items-center justify-center peer-checked:bg-z-dark-moss-green peer-checked:border-gray-300 transition duration-200">
                  <FaCheck className="w-3 h-3 text-white" />
                </span>
                <span>{option.label}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { DropdownMultiple };
